import "./Pillar.css";
import React, { useState } from "react";
import updateUserData from '../../../assets/functions/updateUserData'

function EditProject(props) {
  const activeProject = props.userProfile.projects[props.activeProject]
  const [projectTitle, setProjectTitle] = useState(
    activeProject.title);
  const [projectShortname, setProjectShortname] = useState(
    activeProject.shortName);
  const [projectColor, setProjectColor] = useState(
    activeProject.backgroundColor);

    const handleTitleChange = (event) => {
      setProjectTitle(event.target.value);
    };

    const handleShortnameChange = (event) => {
      setProjectShortname(event.target.value);
    };

    const handleProjectColor = (event) => {
      setProjectColor(event.target.value);
    };

    function resetProjectEdit() {
      props.setActiveProject(null)
    }

    function handleUpdatedProject () {
      let placeholderProject = {...activeProject}
      placeholderProject.title=projectTitle
      placeholderProject.shortName=projectShortname
      placeholderProject.backgroundColor=projectColor
      let placeholderProjectList=[...props.userProfile.projects]
      let indexToChange = placeholderProjectList.indexOf(activeProject)
      placeholderProjectList[indexToChange]=placeholderProject
      updateUserData("updateProjects", placeholderProjectList, props.userProfile, props.setUserProfile, resetProjectEdit)
    }

    function handleDeletedProject () {
      let deletedProjectPlaceholder = props.userProfile.projects;
      const indexToDelete = deletedProjectPlaceholder.indexOf(activeProject);
      console.log(indexToDelete)
      if (indexToDelete > -1) {
        deletedProjectPlaceholder.splice(indexToDelete, 1);
      }
      console.log(deletedProjectPlaceholder)
      updateUserData("updateProjects", deletedProjectPlaceholder, props.userProfile, props.setUserProfile, resetProjectEdit)
    }

  return (
    <div className="editPillarProject">
      <p> {"edit project: " + activeProject.title} </p>
      <div className="projectRow">
                <div>
                    <p className="addProjectTextHeader">project title</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id="projectTitle"
                    value={projectTitle}
                    onChange={handleTitleChange}
                    name="projectTitle"
                    spellCheck="false"
                    />
                </div>
                <div>
                    <p className="addProjectTextHeader">short name</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id="projectShortname"
                    value={projectShortname}
                    onChange={handleShortnameChange}
                    name="projectShortname"
                    spellCheck="false"
                    />
                </div>
                </div>
                <div className="colorTextHeader">
                    <p className="addProjectTextHeader">edit the color tag for your project</p>
                    <input type="color" id="projectColor" value={projectColor} onChange={handleProjectColor}></input>
                </div>
      <div className="pillarButtonRow">
        <p className="pillarEditButton" onClick={() => handleUpdatedProject()}>
          {" "}
          save edited project{" "}
        </p>
        <p
          className="pillarEditButton"
          onClick={() => handleDeletedProject()}
        >
          {" "}
          delete this project{" "}
        </p>
      </div>
    </div>
  );
}

export default EditProject;
